import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import VisitorBasicInfo from "./Forms/VisitorBasicInformation";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Step, StepLabel, Stepper } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import ScrollToFieldError from "../../Utils/ScrollToFieldError";
import CustomButton from "../../Components/Atoms/CustomButton";
import VisitorOtherInformation from "./Forms/VisitorOtherInformation";
import VisitorHostInformation from "./Forms/VisitorHostDetails";
import "./NewVisitor.css";
import InformationShower from "../../Components/Atoms/InformationShower/Index";
import { expression, MODULES } from "../../Constant";
import { useDispatch, useSelector } from "react-redux";
import {
  postVisitorLogResponseClear,
  postVistorLogRequest,
  putVisitorLogRequest,
} from "../../Redux/VisitorLogs/VisitorLogsActions";
import toast from "react-hot-toast";
import VisitorReminderIntervals from "./Forms/VisitorReminderIntervals";
import { getUserRequest } from "../../Redux/GetUser/GetUserActions";

const NewVisitor = () => {
  const { type } = useParams();

  const [searchParams] = useSearchParams();

  const { getUserResponse } = useSelector((state) => state.user);
  const id = searchParams.get("id");

  const { postVisitorLogLoading, postVistorLogResponse } = useSelector(
    (state) => state.visitorLogReducer,
  );

  const [isVerified, setIsVerified] = useState(type === "edit" ? true : false);

  //SEND OTP
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //VERIFY OTP
  const [openVerify, setOpenVerify] = useState(false);
  const handleOpenVerify = () => setOpenVerify(true);
  const handleCloseVerify = () => setOpenVerify(false);

  //
  const [otpDetails, setOtpDetails] = useState({});

  useEffect(() => {
    dispatch(getUserRequest());
  }, []);

  useEffect(() => {
    if (getUserResponse?.data?.otp_feature) {
      setOpen(true);
      setIsVerified(false);
    } else {
      setOpen(false);
      setIsVerified(true);
    }
  }, [getUserResponse]);

  const getStepsValue = (value) => {
    switch (value) {
      case 0:
        return (
          <VisitorBasicInfo
            formik={formik}
            type={type}
            isVerified={isVerified}
            setIsVerified={setIsVerified}
            openVerify={openVerify}
            handleOpenVerify={handleOpenVerify}
            handleCloseVerify={handleCloseVerify}
            open={open && type === "new"}
            handleClose={handleClose}
            setOtpDetails={setOtpDetails}
          />
        );
      case 1:
        return <VisitorOtherInformation formik={formik} type={type} />;
      case 2:
        return <VisitorHostInformation formik={formik} type={type} />;
      case 3:
        return <VisitorReminderIntervals formik={formik} type={type} />;
      default:
        break;
    }
  };
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch();
  const VALIDATION_SCHEMA = [
    Yup.object().shape({
      // id_type: Yup.string().required("Required"),
      // nric: Yup.string()
      //   .nullable()
      //   .when(["$id_type"], ([id_type], schema) => {
      //     if (id_type === "NRIC") {
      //       return Yup.string()
      //         .required("Required")
      //         .matches(expression.nric_regex, expression.nric_message);
      //     }
      //     return schema;
      //   }),

      // fin: Yup.string()
      //   .nullable()
      //   .when(["$id_type"], ([id_type], schema) => {
      //     if (id_type === "FIN") {
      //       return Yup.string()
      //         .required("Required")
      //         .matches(expression.fin_regex, expression.fin_message);
      //     }
      //     return schema;
      //   }),

      // passport: Yup.string()
      //   .nullable()
      //   .when(["$id_type"], ([id_type], schema) => {
      //     if (id_type === "PASSPORT") {
      //       return Yup.string().required("Required");
      //     }
      //     return schema;
      //   }),
      basic_details: Yup.object().shape({
        name: Yup.string().required("Required"),
        contact_no: Yup.string().required("Required"),
        check_in: Yup.date().nullable().required("Required"),
        check_out: Yup.date()
          .nullable()
          .min(
            Yup.ref("check_in"),
            "Check-out date cannot be before check-in date",
          ),
      }),
    }),
    Yup.object().shape({
      other_details: Yup.object().shape({
        from: Yup.string().required("Required"),
        destination: Yup.string().required("Required"),
        level: Yup.string().required("Required"),
        block: Yup.string().required("Required"),
        floor: Yup.string().required("Required"),
        unit_no: Yup.string().required("Required"),
        type: Yup.string().required("Required"),
        purpose_of_visit: Yup.string().required("Required"),
        client: Yup.string().required("Required"),
      }),
    }),
    Yup.object().shape({
      host_details: Yup.object().shape({
        host_department: Yup.string().required("Required"),
      }),
    }),
  ];
  const formik = useFormik({
    initialValues: {
      // id_type: "NRIC", //NRIC,FIN and PASSPORT
      // nric_masking: "",
      // nric: "",
      // nric_char: "",
      // fin_masking: "",
      // fin: "",
      // fin_char: "",
      // passport: "",
      basic_details: {
        name: "",
        contact_no: "",
        description: "",
        check_in: new Date(),
        check_out: "",
        primary: "",
        secondary: "",
      },
      other_details: {
        from: "",
        level: "",
        block: "",
        floor: "",
        unit_no: "#",
        pass_type: "CONTRACTOR PASS",
        pass_no: "",
        purpose_of_visit: "",
        type: "",
        destination: "",
        client: "",
        vehicle_no: "",
        remarks: "",
      },
      host_details: {
        host_department: "",
        host_name: "",
        host_contact_no: "",
      },
      reminder_interval: [],
    },
    onSubmit: (values) => {
      if (activeStep === steps.length - 1) {
        if (!values?.basic_details?.check_out) {
          delete values.basic_details?.check_out;
        }
        if (type === "new") {
          const payload = { ...values, otp_details: otpDetails };
          dispatch(postVistorLogRequest(payload));
        } else {
          dispatch(
            putVisitorLogRequest({
              ...values,
              _id: id,
            }),
          );
        }
      } else {
        setActiveStep((step) => step + 1);
      }
    },
    validationSchema: VALIDATION_SCHEMA[activeStep],
  });
  const STEPS_VALUE = {
    REMINDERS: "REMINDERS",
  };

  console.log(formik.errors, "ERRORS");
  const isPermissionEnabled = useCallback(
    (code) => {
      switch (code) {
        case STEPS_VALUE.REMINDERS:
          const reminder_level =
            getUserResponse?.data?.settings?.reminder_scope || "GLOBAL_LEVEL";
          return reminder_level === "CREATION_LEVEL";
        default:
          return false;
      }
    },
    [getUserResponse],
  );

  const STEPS = useMemo(() => {
    return [
      { name: "Basic Details", permission: true },
      { name: "Other Details", permission: true },
      { name: "Host Details", permission: true },
      {
        name: "Reminders",
        permission: isPermissionEnabled(STEPS_VALUE.REMINDERS), // Or your specific code
      },
    ];
  }, [isPermissionEnabled]);

  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const res = STEPS.filter((e) => e.permission);
    setSteps(res);
  }, [STEPS]);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (postVistorLogResponse?.success) {
      toast.success(postVistorLogResponse?.message);
      navigate("/visitor-logs");
    } else if (postVistorLogResponse?.response?.data) {
      toast.success(postVistorLogResponse?.response?.data?.message);
    }
    return () => {
      dispatch(postVisitorLogResponseClear());
    };
  }, [postVistorLogResponse]);

  return (
    <>
      <div className="cntr">
        <div className="hdrComp">
          {type === "edit" ? <h6>EDIT VISITOR</h6> : <h6>NEW VISITOR</h6>}
          {getUserResponse?.data?.otp_feature &&
          type === "new" &&
          activeStep === 0 &&
          isVerified ? (
            <div>
              <InformationShower
                bg_color={"#fdf1de"}
                para_color={"#e28c0c"}
                sentence={"OTP is successfully verified and get started !"}
                icon_type={"HINT"}
                span_class="index-orange-mild"
              />
            </div>
          ) : getUserResponse?.data?.otp_feature &&
            activeStep === 0 &&
            type === "new" ? (
            <div>
              <InformationShower
                bg_color={"#ffd6d6"}
                para_color="#cf0404"
                span_class="index-red"
                is_cursor={true}
                sentence={
                  "OTP is not verified yet. Click here to verify the OTP and get started !"
                }
                icon_type={"PRIORITY"}
                style={{ cursor: "pointer" }}
                handleClick={handleOpen}
              />
            </div>
          ) : (
            ""
          )}
          <div className="d-flex gap-2">
            {activeStep > 0 && activeStep != steps.length - 1 && (
              <CustomButton
                label="Previous"
                btnType="secondary"
                onClick={handleBack}
                action={"KEYBOARD_RIGHT"}
              />
            )}
            {activeStep != steps.length - 1 && (
              <CustomButton
                onClick={formik.handleSubmit}
                disabled={!isVerified}
                label="Next"
                action={"KEYBOARD_LEFT"}
              />
            )}
          </div>
        </div>
        <div className="p-4" style={{ overflowX: "auto" }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map(({ name }) => (
              <Step key={name}>
                <StepLabel>{name}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
        {activeStep === steps.length ? (
          <div className="d-flex flex-column gap-5 justify-content-center">
            <div>{getStepsValue(activeStep)}</div>
          </div>
        ) : (
          <div className="formWrapper">
            <div className="formContent">
              <form autoComplete="off" onSubmit={formik.handleSubmit}>
                <div className="row">{getStepsValue(activeStep)}</div>
                <div className="btnActnBar">
                  {activeStep > 0 && (
                    <CustomButton
                      label="Previous"
                      btnType="secondary"
                      onClick={handleBack}
                      action={"KEYBOARD_RIGHT"}
                    />
                  )}
                  {activeStep != steps.length - 1 && (
                    <CustomButton
                      type="submit"
                      disabled={!isVerified}
                      label="Next"
                      action={"KEYBOARD_LEFT"}
                    />
                  )}
                  {activeStep === steps.length - 1 && (
                    <CustomButton
                      type="submit"
                      label={"Save"}
                      action={"SAVE"}
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default NewVisitor;
